<template>
  <div class="missions__timer">
    <p>{{ $t("missions.list.timer") }}</p>
    <Timer :secondsLeft="getSecondLeft" :autoStart="true" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Timer from "@libs/timer/timer";
export default {
  name: "MissionsTimer",
  components: {
    Timer,
  },
  computed: {
    ...mapGetters("missions", ["getMissionList"]),
    getSecondLeft() {
      return this.getMissionList[0].expires_at;
    },
  },
};
</script>
